// @flow

import React from 'react';
import { compose } from 'redux';
import {
  withCarBlockProps,
  withGTMImpression,
} from './hocs';
import CarBlock from './carBlock';
import type { StateProps } from './types';
import withPdbIdMapping from '../withPdbIdMapping';

type Props = StateProps & {
  flapoverText?: ?string,
  pdbId: string,
  queryData?: Object,
  packageId: string,
  processGtmEvent: Function,
  tags: Array<string>,
  buttonText: string,
};

const ContainerCarBlock = ({
  consumerPrice,
  configLink,
  defaultImage,
  deliveryText,
  descriptionText,
  engine,
  flapoverText,
  fueltype,
  isAvailable,
  isReserved,
  make,
  model,
  modelInfoLink,
  notAvailableText,
  paymentText,
  pdbId,
  power,
  remarkText,
  packageName,
  basePrice,
  processGtmEvent,
  reservedText,
  tags,
  buttonText,
}: Props) => (
  <CarBlock
    deliveryText={deliveryText || ''}
    consumerPrice={consumerPrice.toString()}
    image={(defaultImage && defaultImage.replace('__width__', '350')) || ''}
    title={`${make} ${model}`}
    subTitle={`${engine} ${power} ${fueltype}`}
    promotionText={flapoverText || descriptionText}
    remarkText={remarkText}
    link={modelInfoLink || configLink || '#'}
    overlay={!isAvailable}
    overlayText={notAvailableText}
    packageName={packageName}
    basePrice={basePrice !== consumerPrice.toString() ? basePrice : null}
    payment={paymentText}
    onClick={() => processGtmEvent(pdbId)}
    isReserved={isReserved || false}
    reservedText={reservedText}
    tags={tags}
    buttonText={buttonText}
  />
);

ContainerCarBlock.defaultProps = {
  flapoverText: null,
  queryData: {},
};

export default compose(
  withPdbIdMapping,
  withCarBlockProps,
  withGTMImpression,
)(ContainerCarBlock);
